import { Language } from '~common/i18n';
import {
  arrayTranslations,
  mergeTranslations,
} from '~admin/view/components/create-event/helper/merge-translations.helper';
import { EventBaseFormData } from '~admin/view/components/details/event-details/event-base-details.component';
import { EventProfileCreateRequest } from '~client/model/admin/event-profile-create-request';
import { EventTranslationRequest } from '~client/model/admin/event-translation-request';
import { EventTranslationRequestItem } from '~client/model/admin/event-translation-request-item';

/**
 * Transforms EventBaseFormData to Partial<EventProfileCreateRequest>
 * @param values
 */
export const getEventBaseDetailsRequest = (
  values: EventBaseFormData,
): Pick<
  EventProfileCreateRequest,
  'eventName' | 'eventNameShort' | 'optionalLongDescription' | 'language'
> => {
  const { eventName, eventDescription, eventLanguage } = values;

  return {
    eventName: eventName[0].value,
    eventNameShort: eventName[0].value,
    optionalLongDescription: eventDescription[0].value,
    language: eventLanguage,
  };
};

/**
 * Transforms EventBaseFormData to Partial<EventTranslationRequest>
 * @param values
 */
export const getEventBaseDetailsTranslationsRequest = (
  values: EventBaseFormData,
): Pick<EventTranslationRequest, 'eventTranslationRequestItems'> => {
  const { eventName, eventDescription } = values;

  const eventTranslations = new Map<Language, EventTranslationRequestItem>();
  mergeTranslations(eventTranslations, 'eventName', eventName);
  mergeTranslations(eventTranslations, 'eventNameShort', eventName);
  mergeTranslations(eventTranslations, 'optionalLongDescription', eventDescription);

  return {
    eventTranslationRequestItems: arrayTranslations(eventTranslations),
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request/event-base-details-request.helper.ts